import { LinkOutlined, ShareAltOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import { Button, useMessage } from 'components/ui';

type CopyButtonProps = {
  onClick?: (arg0: any) => void;
  value?: string;
  legacy?: boolean;
  useIconButton?: boolean;
  [key: string]: any;
};

export const CopyButton: React.FunctionComponent<CopyButtonProps> = ({
  onClick,
  value,
  legacy,
  useIconButton,
  ...props
}) => {
  const { t } = useTranslation();
  const message = useMessage();
  const handleCopy = useCallback(
    e => {
      message.success(t('notifications.success.linkCopied', 'Link copied to clipboard'));
      onClick?.(e);
    },
    [message, onClick, t]
  );

  return (
    <CopyToClipboard text={value} onCopy={handleCopy}>
      {useIconButton ? (
        <Button
          title={t('components.copyLink', 'Copy link')}
          data-testid="image-controls-copy-link"
          {...props}
          icon={legacy ? <LinkOutlined /> : <ShareAltOutlined />}
        />
      ) : (
        <Button
          title={t('components.copyLink', 'Copy link')}
          data-testid="image-controls-copy-link"
          {...props}
        >
          {legacy ? <LinkOutlined /> : <ShareAltOutlined />}
        </Button>
      )}
    </CopyToClipboard>
  );
};
